<script >
const __sfc_main = {};
__sfc_main.props = {
  logo: String
};
export default __sfc_main;
</script>
<template>
    <img class="top-container__logo" :src="logo" />
</template>
<style scoped>
.top-container__logo {
    width: auto !important;
}
</style>
